import { Actualizador } from "./Actualizador";
import { DatosActualizarInvestigacion } from "../DatosActualizarInvestigacion";
import { GrupoDTO, GrupoFiltroDTO, InvestigacionDTO } from "@DTOS";
import "@extensiones";
import { GrupoCuota } from "@shared/clases";
import { GruposFiltrosService } from "../../../../../layout/investigaciones/gruposFiltros.service";

export class GrupoCuotaActualizador extends Actualizador {
    private investigacion: InvestigacionDTO;

    constructor(private gruposFiltrosService: GruposFiltrosService) {
        super();
    }

    public async actualizar(
        investigacion: InvestigacionDTO, datos: DatosActualizarInvestigacion
    ): Promise<InvestigacionDTO> {
        this.investigacion = investigacion.clon();
        await Promise.sequence(datos.gruposCuota!.map(
            async (grupo, index) => await this.procesoGrupoAsync(grupo, index))
        );
        return this.investigacion;
    }

    public esActualizador(datos: DatosActualizarInvestigacion): boolean {
        return datos.gruposCuota != null;
    }

    private async procesoGrupoAsync(grupoCuota: GrupoCuota, index: number) {
        if (this.investigacion == null) {
            return;
        }
        await this.guardarOCrearGrupoFiltroAsync(grupoCuota.grupo.gruposFiltros[0], grupoCuota.grupo);

        this.investigacion.grupos[index] = grupoCuota.grupo;
    }

    private async guardarOCrearGrupoFiltroAsync(grupoFiltro: GrupoFiltroDTO, grupoDTO: GrupoDTO) {
        if (this.investigacion == null) {
            return;
        }
        if (grupoFiltro == null || (grupoFiltro.id === 0 && grupoFiltro.tags.length === 0)) {
            return;
        }

        if (grupoFiltro.tags.length === 0 && grupoFiltro.id !== 0) {
            await this.gruposFiltrosService.eliminarGrupoFiltro(grupoFiltro);
            return;
        }

        if (!grupoFiltro.nombre || grupoFiltro.id === 0) {
            grupoFiltro.asignarNombre(this.investigacion, grupoDTO);
            grupoFiltro.grupo = grupoDTO;
            grupoFiltro.targetPais = grupoDTO.targetPais;

            await this.gruposFiltrosService.agregarGrupoFiltro(grupoFiltro);
        } else {
            await this.gruposFiltrosService.guardarGrupoFiltro(grupoFiltro);
        }
    }
}
